module.exports = __webpack_public_path__ + "img/logo.2c012d80.png";